module.exports = __webpack_public_path__ + "assets/images/project/nusajaya-desktop.jpg?v=73c46b95";